import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import swal from "sweetalert";
import "./MobileShell.css";

// The app shell shown on phones and tablets instead of the desktop navbar:
// a fixed top bar (back, page title, dollar rate), a bottom tab bar with the
// four everyday screens, and a "more" sheet holding every other section.
// It renders the same destinations and calls the same context handlers as the
// desktop navbar in Navbar.js — only the presentation differs.

// Kurdish title shown in the top bar for each route.
const TITLES = {
  "/": "ماڵەوە",
  "/rent": "فرۆشتن",
  "/ipad-rent": "فرۆشتن",
  "/MarketSale": "فرۆشتنی مفرد",
  "/take-money": "پارەوەرگرتن",
  "/add-product": "زیادکردنی کاڵا",
  "/add-wakel": "وەکیلەکان",
  "/add-user": "بەکارهێنەران",
  "/masrufat": "مەسروفات",
  "/setting": "ڕێکخستنەکان",
  "/old-rasid": "قەرزی دەفتەر",
  "/text-bord": "ڕەفە",
  "/All-Koga-3arz": "عەرز",
  "/All-Koga-detail": "زانیاری کاڵا",
  "/online-orders": "داواکارییەکانی ئۆنڵاین",
  "/storefront": "فرۆشگای ئۆنڵاین",
  "/categories": "جۆرەکان",
  "/audit-log": "وردبینی",
  "/back-koga": "گەڕانەوە بۆ کۆگا",
  "/ipad-garanawa": "گەڕانەوە بۆ کۆگا",
  "/Product-Raport": "ڕاپۆرتەکان",
  "/Raport-rozhana": "ڕاپۆرتی ڕۆژانە",
  "/ipad-rozhana": "ڕاپۆرتی ڕۆژانە",
  "/RozhanaMawad": "ڕاپۆرتی کاڵای فرۆشراو",
  "/Raport-wakel": "ڕاپۆرتی وەکیل",
  "/Raport-qarzeWakel": "قەرزی وەکیلەکان",
  "/Raport-qarzrastawxo": "ڕاپۆرتی ڕاستەوخۆ",
  "/Raport-kogajard": "ڕاپۆرتی مەخزەن",
  "/Raport-kala": "ڕاپۆرتی کاڵا",
  "/Raport-qazanj": "ڕاپۆرتی قازانج",
  "/Raport-china": "ڕاپۆرتی چین",
  "/ipad-cin": "ڕاپۆرتی چین",
  "/raporty-kalaynafroshraw": "کاڵای نەفرۆشراو",
  "/raporty-paraynadraw": "پارەی نەگەڕاوە",
  "/raporty-paradan": "ڕاپۆرتی پارەدان",
  "/raporty-paraydarhenraw": "پارەی دەرهێنراو",
  "/raporty-masrufat": "ڕاپۆرتی مەسروفات",
  "/raporty-kasakan": "ڕاپۆرتی کەسەکان",
  "/raporty-mandubakan": "ڕاپۆرتی مەندوبەکان",
  "/raporty-parawargrtn": "ڕاپۆرتی پارەوەرگرتن",
  "/raporty-change": "ڕاپۆرتی پارەگۆڕینەوە",
  "/bas-remembe": "ڕاپۆرتی ڕیمێمبی",
  "/IncomeOutCome": "حساب عام",
  "/Paradan": "پارەدان",
  "/Paradarhenan": "پارە دەرهێنان",
  "/parawargrtn": "پارەوەرگرتن",
  "/input-masruf": "مەسروف",
  "/input-people": "کەسەکان",
  "/Mandub": "مەندوب",
  "/change-money": "پارەگۆڕینەوە",
  "/PriceUpdate": "نوێکردنەوەی نرخ",
  "/qarziasto": "کۆی قەرزی ئەستۆ"
};

const formatDolar = (navdolar) =>
  navdolar === "" || navdolar === null || navdolar === undefined
    ? ""
    : Number(String(navdolar).replace(/,/g, "")).toLocaleString("en-US");

const MobileShell = ({ value }) => {
  const location = useLocation();
  const history = useHistory();
  const [moreOpen, setMoreOpen] = useState(false);

  const {
    navdolar,
    DolarChange,
    role,
    logoutUser,
    disabled_navdolar,
    toggleNavdolar,
    R_zh_wasl_katy,
    D_OpenModal,
    L_user,
    JM_OpenModal,
    K_OpenModal,
    RB_OpenModal,
    R_table,
    HK_pshandan,
    A_OpenModal,
    KD_pshandan,
    IO_OpenModal,
    RDM_OpenModal,
    IT_table,
    OR_pendingCount,
    AL_todayCount
  } = value;

  const isAdmin = role == "ipadadmin" || role == "admin";
  const userId = L_user ? L_user._id : undefined;
  // Same rule the desktop navbar uses: while /rent holds unsaved rows the
  // report dialogs and the settings page are off limits.
  const saleBusy = R_table == true;
  const hasUnsaved = saleBusy || (IT_table && IT_table.length > 0);

  // The sheet covers the page, so the page behind it must not scroll.
  useEffect(() => {
    if (!moreOpen) return undefined;
    document.body.classList.add("ms-lock");
    return () => document.body.classList.remove("ms-lock");
  }, [moreOpen]);

  // While the on-screen keyboard is up, the tab bar only takes space away from
  // the field being typed in (on browsers that shrink the page for the
  // keyboard). body.ms-kb hides it until the keyboard closes.
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    let tallest = vv.height;
    let lastWidth = vv.width;
    const update = () => {
      if (vv.width !== lastWidth) {
        // rotated: start measuring again
        lastWidth = vv.width;
        tallest = vv.height;
      }
      tallest = Math.max(tallest, vv.height);
      const el = document.activeElement;
      const typing =
        !!el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) && !el.readOnly;
      document.body.classList.toggle(
        "ms-kb",
        typing && vv.height < tallest - 160
      );
    };
    vv.addEventListener("resize", update);
    return () => {
      vv.removeEventListener("resize", update);
      document.body.classList.remove("ms-kb");
    };
  }, []);

  const path = location.pathname;
  const isHome = path === "/";
  const title = TITLES[path] || "M-67";
  const rentTo = `/rent?page=${R_zh_wasl_katy}`;

  const busyNotice = () =>
    swal({
      title: "ببورە",
      text: "پسووڵەیەکی فرۆشتنی تەواونەکراوت هەیە. سەرەتا پاشەکەوتی بکە.",
      icon: "warning"
    });

  // Every section of the system. `to` navigates, `run` calls a context handler
  // (both may be set — the desktop navbar does the same for a few entries).
  // `blocked` entries are the ones the desktop navbar disables during a sale.
  const sections = [
    isAdmin && {
      key: "audit",
      label: "وردبینی",
      icon: "fas fa-history",
      color: "#b07cd8",
      to: "/audit-log",
      badge: AL_todayCount
    },
    {
      key: "orders",
      label: "داواکارییەکان",
      icon: "fas fa-receipt",
      color: "#ff7f50",
      to: "/online-orders",
      badge: OR_pendingCount
    },
    {
      key: "categories",
      label: "جۆرەکان",
      icon: "fas fa-tags",
      color: "#2ecc71",
      to: "/categories"
    },
    {
      key: "rdm",
      label: "کاڵای فرۆشراو",
      icon: "fas fa-sitemap",
      color: "#c9b037",
      run: (e) => RDM_OpenModal(e, userId)
    },
    {
      key: "io",
      label: "حساب عام",
      icon: "fas fa-file",
      color: "#7fbf7f",
      run: (e) => IO_OpenModal(e, userId)
    },
    {
      key: "kogadetail",
      label: "زانیاری کاڵا",
      icon: "fa fa-info-circle",
      color: "#e9ecef",
      to: "/All-Koga-detail",
      run: (e) => KD_pshandan(e, userId)
    },
    {
      key: "3arz",
      label: "عەرز",
      icon: "fa fa-shopping-basket",
      color: "#24baf0",
      to: "/All-Koga-3arz",
      run: (e) => HK_pshandan(e, userId)
    },
    {
      key: "market",
      label: "مفرد",
      icon: "fas fa-money-check-alt",
      color: "#eac11e",
      to: "/MarketSale"
    },
    {
      key: "bord",
      label: "ڕەفە",
      icon: "fas fa-pen-square",
      color: "#C9AA49",
      to: "/text-bord"
    },
    {
      key: "addproduct",
      label: "زیادکردنی کاڵا",
      icon: "fas fa-shopping-cart",
      color: "#fcb25f",
      to: "/add-product"
    },
    {
      key: "rent",
      label: "فرۆشتن",
      icon: "fas fa-cart-plus",
      color: "#d5fe77",
      to: rentTo
    },
    {
      key: "wakel",
      label: "وەکیلەکان",
      icon: "fas fa-users",
      color: "#e9ecef",
      to: "/add-wakel"
    },
    {
      key: "takemoney",
      label: "پارەوەرگرتن",
      icon: "fas fa-cash-register",
      color: "#9aa6bd",
      to: "/take-money"
    },
    {
      key: "rozhana",
      label: "ڕاپۆرتی ڕۆژانە",
      icon: "fas fa-calendar-day",
      color: "#24bbc0",
      blocked: saleBusy,
      run: (e) => D_OpenModal(e, userId)
    },
    {
      key: "maxzan",
      label: "ڕاپۆرتی مەخزەن",
      icon: "fas fa-store-alt",
      color: "#E56717",
      blocked: saleBusy,
      run: (e) => JM_OpenModal(e, userId)
    },
    {
      key: "kala",
      label: "ڕاپۆرتی کاڵا",
      icon: "fas fa-shopping-bag",
      color: "#a3c13a",
      blocked: saleBusy,
      run: (e) => K_OpenModal(e, userId)
    },
    {
      key: "masrufat",
      label: "مەسروفات",
      icon: "fas fa-file-invoice-dollar",
      color: "#f0e7d3",
      to: "/masrufat"
    },
    {
      key: "setting",
      label: "ڕێکخستنەکان",
      icon: "fas fa-cog",
      color: "#f0e7d3",
      blocked: saleBusy,
      to: "/setting"
    },
    {
      key: "oldrasid",
      label: "قەرزی دەفتەر",
      icon: "fas fa-hand-holding-usd",
      color: "#B2A6FF",
      to: "/old-rasid"
    },
    {
      key: "remembe",
      label: "ڕاپۆرتی ڕیمێمبی",
      icon: "fa fa-jpy",
      color: "rgb(79, 168, 180)",
      blocked: saleBusy,
      run: (e) => RB_OpenModal(e, userId)
    },
    {
      key: "user",
      label: "بەکارهێنەر",
      icon: "fas fa-user",
      color: "#e9ecef",
      to: "/add-user",
      run: (e) => A_OpenModal(e, userId)
    }
  ].filter(Boolean);

  const tabs = [
    { key: "home", label: "ماڵەوە", icon: "fas fa-home", to: "/", match: ["/"] },
    {
      key: "rent",
      label: "فرۆشتن",
      icon: "fas fa-cart-plus",
      to: rentTo,
      match: ["/rent", "/ipad-rent"]
    },
    {
      key: "market",
      label: "مفرد",
      icon: "fas fa-money-check-alt",
      to: "/MarketSale",
      match: ["/MarketSale"]
    },
    {
      key: "takemoney",
      label: "پارەوەرگرتن",
      icon: "fas fa-cash-register",
      to: "/take-money",
      match: ["/take-money"]
    }
  ];
  const onTab = tabs.some((t) => t.match.includes(path));

  const openSection = (section, e) => {
    if (section.blocked) {
      e.preventDefault();
      busyNotice();
      return;
    }
    setMoreOpen(false);
    if (section.run) section.run(e);
  };

  const tileBody = (section) => (
    <>
      <span className="ms-tile-icon" style={{ color: section.color }}>
        <i className={section.icon} aria-hidden="true"></i>
        {section.badge > 0 && (
          <span className="ms-badge">
            {section.badge > 99 ? "99+" : section.badge}
          </span>
        )}
      </span>
      <span className="ms-tile-label">{section.label}</span>
    </>
  );

  const pendingBadges =
    (OR_pendingCount || 0) + (isAdmin ? AL_todayCount || 0 : 0);

  return (
    <>
      {/* ——— top bar ——— */}
      <header className="ms-topbar">
        <div className="ms-topbar-main">
          {isHome ? (
            <span className="ms-topbar-btn ms-topbar-logo" aria-hidden="true">
              <i className="fas fa-store"></i>
            </span>
          ) : (
            <button
              type="button"
              className="ms-topbar-btn"
              aria-label="گەڕانەوە"
              onClick={() => history.goBack()}
            >
              <i className="fas fa-chevron-right" aria-hidden="true"></i>
            </button>
          )}
          <h1 className="ms-title">{title}</h1>
        </div>
        <div className="ms-rate">
          <span className="ms-rate-sign">$</span>
          <input
            type="text"
            inputMode="numeric"
            maxLength="7"
            value={formatDolar(navdolar)}
            disabled={disabled_navdolar ? false : true}
            className="ms-rate-input"
            placeholder="نرخی دۆلار"
            aria-label="نرخی دۆلار"
            onChange={DolarChange}
          />
          {isAdmin && (
            <button
              type="button"
              className={`ms-rate-toggle ${disabled_navdolar ? "is-on" : ""}`}
              aria-label="گۆڕینی نرخی دۆلار"
              onClick={toggleNavdolar}
            >
              <i
                className={disabled_navdolar ? "fas fa-check" : "fas fa-pen"}
                aria-hidden="true"
              ></i>
            </button>
          )}
        </div>
      </header>

      {/* ——— bottom tab bar ——— */}
      <nav className="ms-tabbar" aria-label="بەشە سەرەکییەکان">
        {tabs.map((tab) => (
          <Link
            key={tab.key}
            to={tab.to}
            className={`ms-tab ${
              !moreOpen && tab.match.includes(path) ? "is-active" : ""
            }`}
          >
            <i className={tab.icon} aria-hidden="true"></i>
            <span>{tab.label}</span>
          </Link>
        ))}
        <button
          type="button"
          className={`ms-tab ${moreOpen || !onTab ? "is-active" : ""}`}
          aria-expanded={moreOpen}
          onClick={() => setMoreOpen(!moreOpen)}
        >
          <span className="ms-tab-iconwrap">
            <i
              className={moreOpen ? "fas fa-times" : "fas fa-th-large"}
              aria-hidden="true"
            ></i>
            {!moreOpen && pendingBadges > 0 && <span className="ms-dot"></span>}
          </span>
          <span>زیاتر</span>
        </button>
      </nav>

      {/* ——— "more" sheet: every section of the system ——— */}
      {moreOpen && (
        <div className="ms-sheet-backdrop" onClick={() => setMoreOpen(false)}>
          <div
            className="ms-sheet"
            role="dialog"
            aria-label="هەموو بەشەکان"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ms-sheet-handle" aria-hidden="true"></div>
            <div className="ms-sheet-head">
              <div className="ms-user">
                <span className="ms-user-avatar">
                  <i className="fas fa-user" aria-hidden="true"></i>
                </span>
                <span className="ms-user-name">
                  {(L_user && L_user.name) || "بەکارهێنەر"}
                </span>
              </div>
              <button
                type="button"
                className="ms-sheet-close"
                aria-label="داخستن"
                onClick={() => setMoreOpen(false)}
              >
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>

            <div className="ms-grid">
              {sections.map((section) =>
                section.to && !section.blocked ? (
                  <Link
                    key={section.key}
                    to={section.to}
                    className="ms-tile"
                    onClick={(e) => openSection(section, e)}
                  >
                    {tileBody(section)}
                  </Link>
                ) : (
                  <button
                    key={section.key}
                    type="button"
                    className={`ms-tile ${section.blocked ? "is-blocked" : ""}`}
                    onClick={(e) => openSection(section, e)}
                  >
                    {tileBody(section)}
                  </button>
                )
              )}
            </div>

            {/* Same guard as the desktop navbar: no logging out over an
                unsaved invoice. */}
            {hasUnsaved ? (
              <button type="button" className="ms-logout" onClick={busyNotice}>
                <i className="fas fa-sign-out-alt" aria-hidden="true"></i>
                <span>چوونەدەرەوە</span>
              </button>
            ) : (
              <Link to="/login" className="ms-logout" onClick={logoutUser}>
                <i className="fas fa-sign-out-alt" aria-hidden="true"></i>
                <span>چوونەدەرەوە</span>
              </Link>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MobileShell;
